/* eslint-disable */
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import DownloadReceiptService from '@/api/digital-gold/dowloadInvoice';
import CloseIcon from '@/assets/images/icons/close-icon.svg';
import DownloadPopup from '@/assets/images/icons/download-popup.svg';
import FailureIcon from '@/assets/images/icons/failed-icon.svg';
import GoldIcon from '@/assets/images/icons/gold-coin-icon.svg';
import ProgressIcon from '@/assets/images/icons/progress-icon.svg';
import RupeeIcon from '@/assets/images/icons/rupee-icon.svg';
import SIPIcon from '@/assets/images/icons/setup-sip.svg';
import VerifiedIcon from '@/assets/images/icons/verified-icon.svg';
import { UserDgWallet } from './userDgWallet';
import SipImage from '@/assets/images/icons/sip-status-blog.svg';
import { useRouter } from 'next/router';
import routes from '@/routes/routes.json';
import { AppliedCoupon } from '@/api/digital-gold/store/buyVerifyStore';
import { useBuyRedirectStore } from '@/api/digital-gold/store/buyGoldRedirectionStore';
import { BuyStepName } from '@/utils/constants/digital-gold';
import GiftStatusTrack from './giftStatus';
import Link from 'next/link';
import { useGiftVerifyStore } from '@/api/digital-gold/store/giftVerifyStore';
import moment from 'moment';

export type PaymentStatusProp = {
  amount: number;
  goldValue: number;
  weight: number;
  transactionId: string;
  transactionDate?: string;
  gst: number;
  status: string;
  appliedCoupon?: AppliedCoupon[] | null;
  couponValue?: number;
  successMessage?: string;
  failureMessage?: string;
  inprogressMessage?: string;
  flowType?: string;
  payableAmount: number;
  orderStatusTimeline?: any;
};

export const PaymentStatus = (props: PaymentStatusProp) => {
  const [invoiceUrl, setInvoiceUrl] = useState('');
  const [orderStatusTimelineData, setOrderStatusTimelineData] = useState([]);

  const {
    amount,
    weight,
    transactionId,
    transactionDate,
    gst,
    status,
    appliedCoupon,
    couponValue,
    successMessage,
    failureMessage,
    inprogressMessage,
    flowType,
    goldValue,
    payableAmount,
    orderStatusTimeline,
  } = props;
  const getInvoiceUrl = async () => {
    const response = await DownloadReceiptService.getS3Url(transactionId);
    if (
      response != undefined &&
      response.data != undefined &&
      response.data.data != undefined
    ) {
      setInvoiceUrl(response.data.data.invoiceUrl);
    }
  };
  const downloadInvoice = () => {
    window.open(invoiceUrl, '_blank');
  };

  const router = useRouter();

  const path = router.pathname;

  const roundOffAmount = parseFloat(amount.toString()).toFixed(2);
  //const roundOffAmount=amount.toFixed(2)
  const goldValueRoundOff = goldValue.toFixed(2);
  const payableRoundoff = payableAmount.toFixed(2);

  const [setBuyStep] = useBuyRedirectStore((state) => [state.setBuyStep]);
  // const flowType = "SIP"
  // const sipType = "SIP"
  const [giftData] = useGiftVerifyStore((state) => [state.giftdata]);

  useEffect(() => {
    const eachOrderTimeline = orderStatusTimeline?.map(
      (eachStatusTimeline: {}) => {
        return eachStatusTimeline;
      }
    );
    setOrderStatusTimelineData(eachOrderTimeline);
  }, [orderStatusTimeline]);

  return (
    <>
      <main className="loanDetails pledge repayment visitSuccess orderSummery singleFlow--lightBlue">
        <div className="container">
          <form autoComplete="off">
            <div className="stepper--content active">
              <div className="row">
                <div className="col-lg-7">
                  <div className="loanDetails__card loanCard">
                    {status.toLowerCase() === 'success' ? (
                      <div className="verified">
                        <Image
                          style={{ color: undefined }}
                          src={VerifiedIcon}
                          alt="verified icon"
                          className="img-fluid"
                        />
                        <div className="right">
                          <p className="text--bold text--white title">
                            {/* {gst != 0
                              ? "Gold Purchase Successful"
                              : "Gold Sell Successful"} */}
                            {/* {path.includes("buy-gold") &&
                              "Gold Purchase Successful"}
                            {path.includes("sell-gold") &&
                              "Gold Sale Successful"}
                            {path.includes("sip") &&
                              `Payment of ${amount} for SIP is Successful`} */}
                            {successMessage}
                          </p>
                          <p className="text--regular text--white desc">
                            Order ID:{' '}
                            <span className="text--semi">{transactionId}</span>{' '}
                            {transactionDate ? (
                              <>
                                <span className="text--semi mx-2">|</span>
                                {moment(
                                  transactionDate,
                                  'YYYY-MM-DD HH:mm:ss.S'
                                ).format('DD MMM, hh:mm A')}
                              </>
                            ) : (
                              ''
                            )}
                          </p>
                        </div>
                      </div>
                    ) : status.toLocaleUpperCase() === 'IN_PROGRESS' ||
                      status.toLocaleUpperCase() === 'INITIATED' ? (
                      <div className="verified in-progress">
                        <Image
                          style={{ color: undefined }}
                          src={ProgressIcon}
                          alt="progress icon"
                          className="img-fluid"
                        />
                        <div className="right">
                          <p className="text--bold text--white title">
                            {inprogressMessage}
                          </p>
                          <p className="text--regular text--white desc">
                            Order ID:{' '}
                            <span className="text--semi">{transactionId}</span>{' '}
                            {transactionDate ? (
                              <>
                                <span className="text--semi mx-2">|</span>
                                {moment(
                                  transactionDate,
                                  'YYYY-MM-DD HH:mm:ss.S'
                                ).format('DD MMM, hh:mm A')}
                              </>
                            ) : (
                              ''
                            )}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div className="verified failed">
                        <Image
                          style={{ color: undefined }}
                          src={FailureIcon}
                          alt="failed icon"
                          className="img-fluid"
                        />
                        <div className="right">
                          <p className="text--bold text--white title">
                            {failureMessage}
                          </p>
                          <p className="text--regular text--white desc">
                            Order ID:{' '}
                            <span className="text--semi">{transactionId}</span>{' '}
                            {transactionDate ? (
                              <>
                                <span className="text--semi mx-2">|</span>
                                {moment(
                                  transactionDate,
                                  'YYYY-MM-DD HH:mm:ss.S'
                                ).format('DD MMM, hh:mm A')}
                              </>
                            ) : (
                              ''
                            )}
                          </p>
                        </div>
                      </div>
                    )}
                    {flowType === 'GIFT' &&
                      status.toLowerCase() === 'success' && (
                        <p className="text--gray text--regular gift_note mt-2 mb-2">
                          <span className="text--green text--bold mr-1">
                            Note:
                          </span>
                          If the receiver does not accept the gifted gold within
                          48 hrs, it will be credited back to your account.
                        </p>
                      )}
                    {flowType === 'GIFT' &&
                      status.toLocaleUpperCase() === 'IN_PROGRESS' && (
                        <p className="text--gray text--regular gift_note_progress mt-2 mb-2">
                          <span className="text--bold mr-1 gift_progress_note">
                            Note:{' '}
                          </span>{' '}
                          Once the transaction is completed, you will receive a
                          notification.
                        </p>
                      )}
                    {flowType === 'GIFT' &&
                      status.toLowerCase() === 'failed' || status.toLowerCase() === 'blocked' && (
                        <p className="text--gray text--regular gift_note_red mt-2 mb-2">
                          <span className="text--bold mr-1 gift_error_note">
                            Note:
                          </span>{' '}
                          Gifting to {giftData.receiverName} has {status.toLowerCase()}.
                        </p>
                      )}

                    <div className="loanCard__title-withChips">
                      <p className="loanCard__title text--bold text--black mb-0">
                        {gst !== 0 ? 'Purchased Gold' : 'Sold Gold'}
                      </p>
                      {status.toLowerCase() === 'success' && (
                        <a
                          href="#" // #
                          className="downloadLink text--bold text--darkBlue m-0"
                          data-toggle="modal"
                          data-target="#downloadModal"
                          onClick={getInvoiceUrl}
                        >
                          <span className="download-icon"></span> Download
                          Receipt
                        </a>
                      )}
                    </div>
                    <div className="loanCard__dates verticle-card card_padding">
                      <div className="left">
                        <span className="text--regular text--gray title">
                          <Image
                            style={{ color: undefined }}
                            src={GoldIcon}
                            alt="gold coin"
                            className="img-fluid mobile-icon"
                          />{' '}
                          Gold weight
                        </span>
                        <span className="text--bold text--black price">
                          <Image
                            style={{ color: undefined }}
                            src={GoldIcon}
                            alt="gold coin"
                            className="img-fluid web-icon"
                          />{' '}
                          {weight} gms
                        </span>
                      </div>
                      <div className="right">
                        <span className="text--regular text--gray title">
                          <Image
                            style={{ color: undefined }}
                            src={RupeeIcon}
                            alt="rupee coin"
                            className="img-fluid mobile-icon"
                          />{' '}
                          Gold value
                        </span>
                        <span className="text--bold text--black price">
                          <Image
                            style={{ color: undefined }}
                            src={RupeeIcon}
                            alt="rupee coin"
                            className="img-fluid web-icon"
                          />{' '}
                          {/* {amount} */}₹{roundOffAmount}
                        </span>
                      </div>
                    </div>

                    {flowType === 'GIFT' && (
                      <div className="recipient_details card_padding">
                        <p className="text--regular text--gray mb-2 gift-gold-checkout-sub-heading">
                          RECIPIENT DETAILS
                        </p>
                        <div className="payable">
                          <p className="text--gray text--regular desc">
                            <span className="big">Name</span>
                          </p>
                          <p className="text--gray text--semi price">
                            {giftData.receiverName}
                          </p>
                        </div>
                        <div className="payable">
                          <p className="text--gray text--regular desc">
                            <span className="big">Mobile Number</span>
                          </p>
                          <p className="text--gray text--semi price">
                            +91{giftData.receiverMobileNumber}
                          </p>
                        </div>
                      </div>
                    )}

                    <div className="payable final">
                      <p className="text--regular text--gray gift-gold-checkout-sub-heading">
                        ORDER DETAILS
                      </p>
                    </div>

                    <div className="payable">
                      <p className="text--gray text--regular desc">
                        <span className="big">Gold Quantity</span>
                      </p>
                      <p className="text--gray text--semi price">
                        {weight} gms
                      </p>
                    </div>
                    <div className="payable">
                      <p className="text--gray text--regular desc">
                        <span className="big">Gold Value</span>
                      </p>
                      <p className="text--gray text--semi price">
                        {/* {amount} */}₹{goldValueRoundOff}
                      </p>
                    </div>
                    {gst != 0 && (
                      <div className="payable">
                        <p className="text--gray text--regular desc">
                          <span className="big">GST (3.0%)</span>
                        </p>
                        <p className="text--gray text--semi price">
                          ₹{gst.toString()}
                        </p>
                      </div>
                    )}

                    {appliedCoupon !== null && !!appliedCoupon && (
                      <div className="payable">
                        <p className="text--gray text--regular desc">
                          <span className="big">
                            Coupon Offer{' '}
                            {appliedCoupon && appliedCoupon[0]?.dgCouponCode}
                          </span>
                        </p>
                        <p className="text--gray text--semi price">
                          ₹{couponValue}
                        </p>
                      </div>
                    )}

                    <div className="payable final">
                      <p className="text--black text--regular desc">
                        <span className="big">
                          {gst != 0
                            ? 'Total Amount Paid'
                            : 'Total Amount Received'}
                        </span>
                      </p>
                      <p className="text--black text--bold price">
                        ₹{/* {amount} */}
                        {payableRoundoff}
                      </p>
                    </div>
                    {/**
                     * @summary - Might be required when the backend send the payment method
                     */}
                    {/* <div className="paymentDetail-info insideCard">
                      <p className="text--black text--bold title">
                        Payment Method
                      </p>
                      <div className="detail">
                        <Image 
style={{ color: undefined }}
                          src={UPIIcon}
                          alt="UPI logo"
                          className="img-fluid"
                        />
                        <div className="right">
                          <p className="text--black text--bold title">
                            username@bankname.com
                          </p>
                          <p className="text--gray text--regular desc">
                            UPI transfer
                          </p>
                        </div>
                      </div>
                    </div> */}
                    {flowType === 'SIP' ? (
                      <div className="action-container mt-3">
                        <Link
                          href={routes.buyGoldLanding}
                          onClick={() => setBuyStep(BuyStepName.buyLanding)}
                          className="custom__button custom__button--dark border-btn backBtn text--bold w-100 mr-md-2 ml-0"
                          id="DG_payment-home"
                        >
                          Go to Home Page
                        </Link>
                        {/* </a> */}

                        <Link
                          className="custom__button custom__button--dark text--semi w-100 ml-0"
                          type="button"
                          href={routes.manageSIP}
                          id="DG_manage-sip"
                        >
                          Manage your SIP
                        </Link>
                      </div>
                    ) : (
                      <Link
                        href={routes.buyGoldLanding}
                        id="DG_go-to-home"
                        onClick={() => {
                          setBuyStep(BuyStepName.buyLanding);
                        }}
                        className="custom__button custom__button--dark text--bold w-100 mt-3 dg-ctas"
                      >
                        Go to Home
                      </Link>
                    )}
                  </div>
                </div>
                <div className="col-lg-5">
                  <UserDgWallet note={false} />
                  {flowType === 'GIFT' && (
                    <div className="loanDetails__card loanCard setupSip">
                      <p className="text--black text--bold gifting-status-heading">
                      eSwarna Digital Gold Gifting Status
                      </p>
                      <GiftStatusTrack
                        orderStatusTimelineData={orderStatusTimelineData}
                      />
                    </div>
                  )}
                  {flowType ===
                  'SIP' ? //         src={"./assets/images/one-coin.svg"} //     {/* <div className="item"> //   <div className="coin-chart"> //   </p> //     years, making it one of the best assets to invest. //     Gold has performed exceedingly well over the last 20 //   <p className="loanCard__desc text--regular text--gray mb-0"> //   </p> //     Setup SIP as Low as ₹10 //   <p className="loanCard__title with-desc text--bold text--black"> // <div className="loanDetails__card loanCard setupSip with-chart tablet-margin"> //         className="img-fluid" //       <Image
                  //         alt="coin"
                  //       />
                  //       <p className="label text--regular text--gray">
                  //         30 Days
                  //       </p>
                  //       <p className="title text--bold text--black">
                  //         + 2.24 %
                  //       </p>
                  //     </div>
                  //     <div className="item">
                  //       <Image
                  //         className="img-fluid"
                  //         src={"./assets/images/two-coin.svg"}
                  //         alt="coin"
                  //       />
                  //       <p className="label text--regular text--gray">
                  //         5 Years
                  //       </p>
                  //       <p className="title text--bold text--black">
                  //         + 56.24 %
                  //       </p>
                  //     </div>
                  //     <div className="item">
                  //       <Image
                  //         className="img-fluid"
                  //         src={"./assets/images/multi-coins.svg"}
                  //         alt="coin"
                  //       />
                  //       <p className="label text--regular text--gray">
                  //         20 Years
                  //       </p>
                  //       <p className="title text--bold text--black">
                  //         + 953.47 %
                  //       </p>
                  //     </div> */}
                  //     <Image
                  //       src={SipImage}
                  //       alt="sip"
                  //       className="m-auto w-100"
                  //     />
                  //   </div>
                  //   <p className="text--regular text--gray coin-chart-label">
                  //     Automate the process of buying digital gold and see it
                  //     grow
                  //   </p>
                  //   <a
                  //     href="#"
                  //     className="custom__link custom__link--dark custom__link-arrow text--darkBlue text--bold"
                  //   >
                  //     Explore now
                  //   </a>
                  // </div>
                  null : (
                    <div className="loanDetails__card loanCard setupSip">
                      <div className="loanCard__title-withChips">
                        <div className="left">
                          <p className="loanCard__title with-desc text--bold text--black">
                            Setup SIP as Low as ₹10
                          </p>
                          <p className="loanCard__desc text--regular text--gray mb-0">
                            Automate the process of buying eSwarna digital gold and see
                            it grow over time
                          </p>
                          <a
                            href="https://qrco.de/mfone"
                            className="custom__link custom__link--dark custom__link-arrow text--darkBlue text--bold"
                            id="DG_invest-sip"
                          >
                            {/* Invest Now */}
                            Invest in SIP on our app
                          </a>
                        </div>
                        <div className="right">
                          <Image
                            style={{ color: undefined }}
                            src={SIPIcon}
                            alt="sip"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>
      <div
        className="modal loanDetails__modal addressDetail__modal successModal downloadModal fade"
        id="downloadModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="downloadModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="header mb-0 border-0 p-0">
              <div className="modal__title justify-content-end mb-0">
                <a href="javascript:void(0)" data-dismiss="modal">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={CloseIcon}
                    alt="close icon"
                  />
                </a>
              </div>
            </div>
            <div className="successMessage">
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={DownloadPopup}
                alt="download icon"
              />
              <p className="text--black text--bold title">
                You are downloading an advanced receipt
              </p>
              <p className="text--gray text--regular desc">
                The final invoice will be sent across to you via SMS and email
                within 24 hrs.
              </p>
            </div>
            <div className="action-container">
              <a
                href="javascript:void(0)"
                className="custom__button border-btn text--semi w-100 ml-0"
                data-dismiss="modal"
                id="DG_invoice-cancel"
              >
                Cancel
              </a>
              <a
                href="javascript:void(0)"
                className="custom__button custom__button--dark text--semi w-100"
                onClick={downloadInvoice}
                id="DG_download-invoice"
              >
                Download
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
